module.exports = __webpack_public_path__ + "img/buy_airtime.9bacda2f.svg";